module.exports = __webpack_public_path__ + "assets/monitor0.jpg?c82fd0346429322a2ed896618bc59876";